import { Slider } from '@/components/ui/slider'

interface SliderFieldProps {
  label: string
  value: number
  onChange: (v: number) => void
  min: number
  max: number
  step: number
  formatValue?: (v: number) => string
  unit?: string
}

export function SliderField({ label, value, onChange, min, max, step, formatValue, unit = '' }: SliderFieldProps) {
  const display = formatValue ? formatValue(value) : `${value}${unit}`

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-xs font-medium text-muted-foreground">{label}</label>
        <span className="text-xs font-semibold tabular-nums font-mono text-primary bg-primary/10 px-2 py-0.5 rounded-md min-w-[3.5rem] text-center">
          {display}
        </span>
      </div>
      <Slider
        value={[value]}
        onValueChange={([v]) => onChange(v)}
        min={min}
        max={max}
        step={step}
        className="w-full [&_[role=slider]]:h-4 [&_[role=slider]]:w-4 [&_[role=slider]]:bg-primary [&_[role=slider]]:border-0 [&_[role=slider]]:shadow-[0_0_8px_hsl(var(--primary)/0.4)]"
      />
      <div className="flex justify-between text-[10px] text-muted-foreground/60">
        <span>{formatValue ? formatValue(min) : `${min}${unit}`}</span>
        <span>{formatValue ? formatValue(max) : `${max}${unit}`}</span>
      </div>
    </div>
  )
}
